export default __webpack_public_path__ + "static/luckmon-c59b8967a52f969617cf8c89e4f8e676.mp4";